// Keyboard keys (mono 10.5, rule-strong hairline, 3px radius, raised).
//   <Kbd>Ctrl</Kbd>                       one key
//   <Kbd keys={["Ctrl", "Enter"]} />      a combination: one <kbd> per key, space-separated (keys are words on Linux/Windows)
import { Fragment, type ReactNode } from "react";

export function Kbd({ children, keys, className }: { children?: ReactNode; keys?: string[]; className?: string }) {
  if (!keys) return <kbd className={className}>{children}</kbd>;
  return (
    <>
      {keys.map((k, i) => (
        <Fragment key={`${k}-${i}`}>
          {i > 0 && " "}
          <kbd className={className}>{k}</kbd>
        </Fragment>
      ))}
    </>
  );
}
